<template>
  <div class="table_view" v-loading="loading">
    <el-table :data="tableData" style="width: 100%" :border="true">
      <el-table-column fixed prop="pointName" label="分类">
           <template slot-scope="scope">
          <div @click="toThreeTable(scope.row)" class="top">
          <span v-if="scope.row.clsVnName == null" class="bd">
            {{ scope.row.pointName }}
          </span>
          <span class="bd" v-else>{{ scope.row.clsVnName +' — '+ scope.row.pointName }}</span>
          </div>
        </template>
          </el-table-column>
      <el-table-column prop="pointCount" label="总点击次数（次）">
        <template slot-scope="scope">
          <div @click="toThreeTable(scope.row)" class="top">
            {{ scope.row.pointCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="userCount" label="总点击人数（人）">
        <template slot-scope="scope">
          <div @click="toThreeTable(scope.row)" class="top">
            {{ scope.row.userCount }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import yklFirst from "@/api/visualization";
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      module:'',
    };
  },
  methods: {
    // 获取二级表格
    async getTwoTable() {
      this.$nextTick(() => {
        // let newTimes = this.$moment().format("YYYY-MM-DD"); // 当前天数（当前系统的时间）
        // this.$parent.timeData[0] = newTimes; // 默认今天时间    // 时间参数清空
        // this.$parent.timeData[1] = newTimes; // 默认今天时间
        if (this.$parent.timeData) {
          const time = JSON.parse(JSON.stringify(this.$parent.timeData));
          this.$parent.formLabelAlign.examBeginDate = this.$moment(
            time[0]
          ).format("YYYY-MM-DD HH:mm:ss");
          this.$parent.formLabelAlign.examEndDate = this.$moment(
            time[1]
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      });
      const obj = {
        parentId: this.$parent.rowObj.parentId,
        beginTime: this.$parent.timeData[0] + " 00:00:00", // 开始时间
        endTime: this.$parent.timeData[1] + " 23:59:59", // 结束时间
      };
      const { data } = await yklFirst.yklTwoEvent(obj);
      if (data.Status == 200) {
        this.tableData = data.Data.list;
        this.module = data.Data.module
        // console.log(data);
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Data);
      }
    },
    // 跳转第三层表格
    toThreeTable(item) {
        item.module = this.module
        this.$emit('pointId',item)
        // console.log(item.pointId);
    },
  },
  created() {
    this.getTwoTable();
  },
};
</script>

<style lang="scss" scoped>
.bd {
  color: #1890ff;
  border-bottom: 1px solid #1890ff;
}
.top{
    cursor: pointer;
}
</style>